import Vue from 'vue';
export const eventBus = new Vue();



// WEBPACK FOOTER //
// ./src/eventBus.js